<template>
  <nav class="mb-10">
    <AlertMessages
      v-if="alertValue"
      alert-type="error" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-form
      ref="form"
      v-model="valid"
      @keyup.enter="addPeople"
      @submit.prevent
    >
      <v-row class="fill-height">
        <v-col
          cols="12"
          lg="8"
          offset-lg="2"
          class="pa-2"
        >
          <v-row>
            <v-col
              cols="11"
              class="mx-auto pb-0"
            >
              <p class="text-h5 font-weight-bold">
                {{ $t('choosePeople') }}
              </p>
              <p
                v-if="!mobile()"
                class="text-body-1 greytext--text"
              >
                {{ $t('choosePeopleText') }}
              </p>
              <p class="text-body-1 ml-4 md-ml-10">
                <input
                  v-model="allSelected"
                  data-testid="checkbox-select-all"
                  type="checkbox"
                  :disabled="!users.length"
                  @click="selectAll"
                > {{ $t('selectAllPeopleText') }}
              </p>
            </v-col>
          </v-row>

          <v-row
            v-if="users && users.length > 0 && !loadingData"
            align="center"
            class="mx-auto"
          >
            <v-col
              cols="11"
              class="mx-auto px-0"
            >
              <v-card
                v-for="user in users"
                :key="user.id"
                rounded="xxl"
                class="my-2 solo"
              >
                <v-hover>
                  <v-row
                    v-if="mobile()"
                    slot-scope="{ hover }"
                    no-gutters
                    :class="`py-3 elevation-${hover? 8 : 2 }`"
                    @click="selectUser(user)"
                  >
                    <v-col
                      cols="1"
                      class="d-flex justify-left align-center"
                    >
                      <input
                        ref="checkboxRef"
                        v-model="userIds"
                        data-testid="user-email-checkbox"
                        class="ml-3"
                        type="checkbox"
                        :value="user.attributes.email"
                        :ref_id="user.id"
                        @click="selectUser(user)"
                      >
                    </v-col>
                    <v-col 
                      cols="11"
                      class="d-flex justify-left align-center"
                    >
                      <v-avatar
                        size="38"
                        class="mr-2 ml-4"
                      >
                        <img
                          v-if="user.attributes.avatar_thumb == null"
                          :src="defaultImage"
                        />
                        <img v-else :src="`${user.attributes.avatar_thumb}`" />
                      </v-avatar>
                      <div class="mail-name text-no-wrap text-truncate mr-4">
                        <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                          {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                        </v-card-text>
                        <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                          {{ user.attributes.email }} 
                        </v-card-text>
                      </div>
                    </v-col>
                   </v-row>
                </v-hover>
                <v-hover>
                  <v-row
                    v-if="!mobile()"
                    slot-scope="{ hover }"
                    no-gutters
                    :class="`py-4 elevation-${hover? 8 : 2 }`"
                    @click="selectUser(user)"
                  >
                    <v-col
                      md="1"
                      class="d-flex justify-left align-center"
                    >
                      <input
                        ref="checkboxRef"
                        v-model="userIds"
                        data-testid="user-email-checkbox"
                        class="ml-4"
                        type="checkbox"
                        :value="user.attributes.email"
                        :ref_id="user.id"
                        @keyup.enter.prevent
                        @click="selectUser(user)"
                      >
                    </v-col>
                    <v-col
                      md="5"
                      class="d-flex justify-left align-center"
                    >
                    <v-avatar size="38" class="mx-2">
                      <img
                        v-if="user.attributes.avatar_thumb == null"
                        :src="defaultImage"
                      />
                      <img v-else :src="`${user.attributes.avatar_thumb}`" />
                    </v-avatar>
                    <div class="ml-3">
                      <div class="text-body-2 grey--text justify-left">
                        {{ $t('name') }}
                      </div>
                      <div class="text-body-1 darktext--text">
                        {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                      </div>
                    </div>
                    </v-col>

                    <v-col
                      md="6"
                      class="pl-2"
                    >
                    <div class="text-body-2 grey--text justify-left">
                      {{ $t("mail") }}
                    </div>
                    <div class="text-body-1 darktext--text">
                      {{ user.attributes.email }}
                    </div>
                    </v-col>
                  </v-row>
                </v-hover>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="users && users.length == 0 && !loadingData">
            <v-col
              cols="11"
              class="mx-auto px-0"
            >
              <div
                :class="{'custom-center': !mobile()}"
                class="greytextlight--text text-h6 text-md-h5 font-weight-bold mx-auto pa-4"
              >
                {{ $t('emptyAddUserToTargetGroupPageText') }}
              </div>
            </v-col>
          </v-row>

          <Pagination
            v-model="pageNumber"
            class="mb-16"
            circle
            :data-length="usersInfo.total"
            :page-number="usersInfo.currentPage"
            total-visible="5"
            :size="size"
            @input="handlePageChange"
          />
        </v-col>
      </v-row>

      <v-footer
        fixed
        color="white"
      >
        <v-row>
          <v-col
            fixed
            align="center"
          >
            <FormFixedFooter
              next-button-text="add"
              :loading="loading"
              :cancel-button-link="'/target-group/'+tgId"
              @proceedSubmit="addPeople"
            />
          </v-col>
        </v-row>
      </v-footer>
    </v-form>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { addPeopleToTargetGroup } from '../../api/targetGroupApi'
import { getUsersNotAddedToTargetGroup } from '../../api/spaceApi'
import Pagination from '../../components/Pagination'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import FormFixedFooter  from '../../components/FormFixedFooter'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        Pagination,
        FormFixedFooter,
        AlertMessages
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            selected: [],
            allSelected: false,
            userIds: [],
            users: [],
            usersInfo: { 
                currentPage: 1,
                total: 1,
            },
            spaceId: window.$cookies.get('space_id'),
            error:'',
            alertMsg:'fgsdfgsdfgsdfgsdfg',
            alertValue:false,
            defaultImage: require('../../assets/user_images/profile-avatar.png'),
            pageNumber: 1,
            size: 20,
            link: {title: '', route: '/audiences/invite'},
            loadingData: false,
            valid:true,
            tgId: this.$route.params.id,
        }
    },
    computed: {
       loading(){
            if(!this.users.length || !this.userIds.length || this.loadingData){
                return true
            }
            return false
        }
    },

    async created(){
        this.loadingData = true
        await this.fetchUsers()
        this.loadingData = false
    },
    methods:{
        selectAll() {
            this.userIds = []
            if (!this.allSelected) {
                for (var user in this.users) {
                    this.userIds.push(this.users[user].attributes.email.toString())
                }
            }
        },
        async addPeople(){
            this.loadingData = true
            try {
                let data = {
                    data: {
                        type: "target-group-users", 
                        attributes: {
                            user_email: this.userIds
                        },
                    }
                }
                const response = await addPeopleToTargetGroup(this.tgId, data)
                if(response.status){
                    if(response.status == 200) {
                        this.$router.push({name: 'ViewTargetGroup', params: {successfullyAddedPeople: true}})
                    }
                }  
            } catch (e) {
                if(e.response){
                    this.alertValue=true
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
            this.loadingData = false
        },

        handlePageChange(value){
            this.usersInfo.currentPage = value
            this.pageNumber = value
            this.fetchUsers()
        },
        showActivePeople(){
            this.$router.push({path: '/audiences/people'})
        },
        async fetchUsers(){
            try {
                const response = await getUsersNotAddedToTargetGroup(this.spaceId,this.tgId,this.pageNumber, this.size)
               
                if(response.status){
                    if(response.status == 200) {
                        this.users = response.data.data
                        window.scrollTo(0,0)
                        this.usersInfo = response.data.meta
                    }
                }
            } catch (e) {
                
                if(e.response){
                    this.alertValue=true
                    if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },

        selectUser(user){
            this.$refs.checkboxRef.find(ref => ref.attributes.ref_id.value === user.id).click()
            this.allSelected = false
        }
    }
}
</script>
